import React, { useEffect, useRef, useState } from "react";
import {
  AiOutlineClockCircle,
  AiOutlineDelete,
  AiOutlineShareAlt,
} from "react-icons/ai";
import { MdBookmark, MdOutlineLocationOn } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import HelpCenter from "../reusble_components/helpCenter";
import { IoMdRefresh } from "react-icons/io";
// import { Menu, MenuItem, IconButton } from "@mui/material";
import { HiDotsVertical } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { toJS } from "mobx";
import JobShare from "./Components/Job";
import InterviewPopup from "./InterviewPopup";
import LoadingAnime from "../reusble_components/loadingAnime";
import "./HistoryPage.css";

import ApplicantLabelPopup from "./Resume/applicant_labelPopup";
import ClientPopup from "./ClientPopup";
import HistoryJobpostCard from "../dashboard/history/historyJobpostCard";
import MailTypePopup from "../reusble_components/popup/mailTypePopup";
import MailPopup from "./MailPopup";
import { mails } from "../../helpers/constantVariables";
import { apiGet } from "../../api/api_methods";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader";
import CustomButton from "../reusble_components/buttons/expandingbutton";

export default function History() {
  const [selectedButton, setSelectedButton] = useState("job posts");
  const [section, setSection] = useState(true);
  const { RecuiterStore, LabelStore, PopupStore } = useStores();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const pag = Number(query.get("page")) || 0;
  const button = query.get("button") || "All";
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [remainderLoader, setRemainderLoader] = useState(false);

  useEffect(() => {
    if (button === "All") {
      setSelectedButton("All");
      if (RecuiterStore.refreshObject.history === 0) {
        RecuiterStore.fetchAllInvitations(pag * 10);
        RecuiterStore.refreshObject.history = 1;
      }
    }
    if (button === "job posts") {
      // alert("hello");
      setSelectedButton("job posts");
      RecuiterStore.setRecuirterJobPostSkip(pag * 10);
      RecuiterStore.fetchJobPostsForHistory(true);
    }
    if (button === "Interviews") {
      setSelectedButton("Interviews");
      RecuiterStore.setRecuirterInterviewSkip(pag * 10);
      RecuiterStore.fetchCompanyInvitations(true);
    }

    if (button === "Mcq") {
      // alert("hell");
      setSelectedButton("Mcq");
      RecuiterStore.fetchmcqinvitation(pag * 10);
    }
    if (button === "Resume Analyzer") {
      setSelectedButton("Resume Analyzer");
      RecuiterStore.fetchjd(pag * 10);
    }
  }, [button, pag]);

  useEffect(() => {
    if (button === "job posts" && RecuiterStore.recuirterjobpostcount > 0) {
      setPage(Math.ceil(RecuiterStore.recuirterjobpostcount / 10));
    }
  }, [RecuiterStore.recuirterjobpostcount, button]);

  // useEffect(() => {
  //  alert("updated",selectedButton);
  // }, [selectedButton]);

  useEffect(() => {
    if (button === "All" && RecuiterStore.allInvitations?.count > 0) {
      setPage(Math.ceil(RecuiterStore.allInvitations?.count / 10));
    }
  }, [RecuiterStore.allInvitations, button]);

  useEffect(() => {
    if (button === "Interviews" && RecuiterStore.recuirterinverviewcount > 0) {
      setPage(Math.ceil(RecuiterStore.recuirterinverviewcount / 10));
    }
  }, [RecuiterStore.recuirterinverviewcount, button]);

  useEffect(() => {
    if (button === "Resume Analyzer" && RecuiterStore.resumeCount > 0) {
      setPage(Math.ceil(RecuiterStore.resumeCount / 10));
    }
  }, [RecuiterStore.resumeCount, button]);

  useEffect(() => {
    if (button === "Mcq" && RecuiterStore.mcqcount > 0) {
      setPage(Math.ceil(RecuiterStore.mcqcount / 10));
    }
  }, [RecuiterStore.mcqcount, button]);

  // Recalculate page when returning to the component (when location changes or component mounts)
  useEffect(() => {
    // Only recalculate if we have data available
    if (button === "All" && RecuiterStore.allInvitations?.count > 0) {
      setPage(Math.ceil(RecuiterStore.allInvitations?.count / 10));
    } else if (
      button === "job posts" &&
      RecuiterStore.recuirterjobpostcount > 0
    ) {
      setPage(Math.ceil(RecuiterStore.recuirterjobpostcount / 10));
    } else if (
      button === "Interviews" &&
      RecuiterStore.recuirterinverviewcount > 0
    ) {
      setPage(Math.ceil(RecuiterStore.recuirterinverviewcount / 10));
    } else if (button === "Mcq" && RecuiterStore.mcqcount > 0) {
      setPage(Math.ceil(RecuiterStore.mcqcount / 10));
    } else if (button === "Resume Analyzer" && RecuiterStore.resumeCount > 0) {
      setPage(Math.ceil(RecuiterStore.resumeCount / 10));
    }
  }, [location.key, button]);

  const navigate = useNavigate();

  const handleSelectedButton = (button) => {
    setSelectedButton(button);
    if (button === "All") {
      setPage(
        (RecuiterStore.recuirterinverviewcount +
          RecuiterStore.recuirterjobpostcount) /
          10 +
          1
      );
      RecuiterStore.fetchAllInvitations();
      navigate(`/company/activity?page=${0}&button=${button}`);
    } else if (button === "job posts") {
      setPage(RecuiterStore.recuirterjobpostcount / 10);
      RecuiterStore.fetchJobPostsForHistory(true);
      navigate(`/company/activity?page=${0}&button=${button}`);
    }
    if (button === "Interviews") {
      setPage(RecuiterStore.recuirterinverviewcount / 10);
      RecuiterStore.fetchCompanyInvitations(true);
      navigate(`/company/activity?page=${0}&button=${button}`);
    }
    if (button === "Mcq") {
      setPage(RecuiterStore.mcqcount / 10);
      RecuiterStore.fetchmcqinvitation();
      navigate(`/company/activity?page=${0}&button=${button}`);
    }
    if (button === "Resume Analyzer") {
      setPage(RecuiterStore.resumeCount / 10);
      RecuiterStore.fetchjd();
      navigate(`/company/activity?page=${0}&button=${button}`);
    }
  };
  // Removed duplicate useEffect hooks - page calculation is handled above based on button selection

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return `${day} ${month}`;
  };

  const calculateCompletedInterviews = (array) => {
    return array?.reduce((acc, curr) => {
      if (curr?.isInterviewCompleted) {
        acc += 1;
      }
      return acc;
    }, 0);
  };

  const calculatePublishedResults = (array) => {
    return array?.reduce((acc, curr) => {
      if (curr?.isResultPublished) {
        acc += 1;
      }
      return acc;
    }, 0);
  };
  const top = useRef();
  const handlePageClick = async (page) => {
    if (top.current) {
      top.current.scrollIntoView({ behavior: "smooth" });
    }

    setRemainderLoader(true);
    if (selectedButton === "job posts") {
      await RecuiterStore.fetchJobPostsForHistory(page.selected * 10);
    } else if (selectedButton === "Interviews") {
      RecuiterStore.setRecuirterInterviewSkip(page.selected * 10);
      await RecuiterStore.fetchCompanyInvitations(true);
    } else if (selectedButton === "Mcq") {
      await RecuiterStore.fetchmcqinvitation(page.selected * 10);
    } else if (selectedButton === "Resume Analyzer") {
      await RecuiterStore.fetchjd(page.selected * 10);
    } else if (selectedButton === "All") {
      await RecuiterStore.fetchAllInvitations(page.selected * 10);
    }
    setRemainderLoader(false);
    navigate(
      `/company/activity?page=${page.selected}&button=${selectedButton}`
    );
  };

  const checkSalary = (currency, salary) => {
    if (salary === undefined || salary === null) {
      return "N/A";
    }
    if (currency == "₹") {
      if (salary >= 10000000)
        return `${currency + " " + (salary / 10000000).toFixed(1)} Cr`; // Crore
      if (salary >= 100000)
        return `${currency + " " + (salary / 100000).toFixed(1)} L`; // Lakh
      if (salary >= 1000)
        return `${currency + " " + (salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "$") {
      if (salary >= 1000)
        return `${currency + " " + (salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "€") {
      if (salary >= 1000000)
        return `${currency + " " + (salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000)
        return `${currency + " " + (salary / 1000).toFixed(0)} K`; // Thousand
    } else if (currency == "UGX") {
      if (salary >= 1000000)
        return `${currency + " " + (salary / 1000000).toFixed(1)} M`; // Million
      if (salary >= 1000)
        return `${currency + " " + (salary / 1000).toFixed(0)} K`; // Thousand
    }
    return salary; // Return as is if it doesn't meet the above conditions
  };

  const handleMode = (mode) => {
    if (mode === "workFromOffice") {
      return "Work From Office";
    } else if (mode === "workFromHome") {
      return "Work From Home";
    } else {
      return "hybrid";
    }
  };

  const timestampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "P.M." : "A.M.";

    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format minutes to ensure two digits
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    // Combine parts into the final format
    return `${day} ${month} ${hours}:${formattedMinutes} ${ampm}`;
  };

  //scroll to top
  useEffect(() => {
    // top.current.scrollIntoView({ behavior: "smooth" });
  }, []);

  function getSub(template, variables) {
    // Replace placeholders in subject and body with variable values

    const filledSubject = template.replace(
      /\[([^\]]+)\]/g,
      (_, key) => variables[key] || `[${key}]`
    );

    return filledSubject;
  }

  function getBody(template, variables) {
    const filledBody = template.replace(
      /\[([^\]]+)\]/g,
      (_, key) => variables[key] || `[${key}]`
    );

    return filledBody;
  }
  const categorizeResumeApplicants = (applicants) => {
    const categories = {
      completed: [],
      incomplete: [],
      notStarted: [],
      shortlisted: [],
      rejected: [],
      hired: [],
      pending: [],
    };
    applicants.forEach((applicant) => {
      const { match, email } = applicant;
      try {
        if (match[0]?.score > 79) {
          categories.shortlisted.push(email);
        } else {
          categories.rejected.push(email);
        }
      } catch (error) {}
      categories.completed.push(email);
    });
    return categories;
  };
  const categorizeApplicants = (applicants) => {
    const categories = {
      completed: [],
      incomplete: [],
      notStarted: [],
      shortlisted: [],
      rejected: [],
      hired: [],
      pending: [],
    };

    applicants.forEach((applicant) => {
      const {
        userId,
        jobPostId,
        mockTest,
        technicalInterview,
        hrInterview,
        isShortlisted,
        isRejected,
        isHired,
      } = applicant;
      const email = userId?.mail;

      // Add to specific categories based on status flags
      if (isShortlisted) categories.shortlisted.push(email);
      if (isRejected) categories.rejected.push(email);
      if (isHired) categories.hired.push(email);

      // Check if all isShortlisted, isRejected, and isHired are false
      if (!isShortlisted && !isRejected && !isHired) {
        categories.pending.push(email);
      }

      // Check if all jobPostId fields are null
      const hasAssessments =
        jobPostId?.mockTest ||
        jobPostId?.technicalInterview ||
        jobPostId?.hrInterview;
      if (!hasAssessments) {
        categories.completed.push(email);
        return;
      }

      // Check the status of individual assessments
      const isMockTestComplete =
        jobPostId?.mockTest === null || mockTest?.isCompleted;
      const isTechInterviewComplete =
        jobPostId?.technicalInterview === null ||
        (technicalInterview?.isInterviewCompleted &&
          technicalInterview?.isResultPublished);
      const isHRInterviewComplete =
        jobPostId?.hrInterview === null ||
        (hrInterview?.isInterviewCompleted && hrInterview?.isResultPublished);

      const isAllComplete =
        isMockTestComplete && isTechInterviewComplete && isHRInterviewComplete;
      const isAnyComplete =
        isMockTestComplete || isTechInterviewComplete || isHRInterviewComplete;

      if (isAllComplete) {
        categories.completed.push(email);
      } else if (isAnyComplete) {
        categories.incomplete.push(email);
      } else {
        categories.notStarted.push(email);
      }
    });

    return categories;
  };
  const categorizeInterviewApplicants = (interviews) => {
    const categories = {
      shortlisted: [],
      rejected: [],
      pending: [],
      completed: [],
      incomplete: [],
      notStarted: [],
    };

    interviews.forEach((interview) => {
      const { interviewee, status, isInterviewCompleted, isResultPublished } =
        interview;
      const email = interviewee?.mail;

      // Categorize based on the status field
      switch (status) {
        case 1: // Shortlisted
          categories.shortlisted.push(email);
          break;
        case 2: // Rejected
          categories.rejected.push(email);
          break;
        case 0: // Pending
          categories.pending.push(email);
          break;
        default:
          break;
      }

      // Check interview completion and result publication status
      if (isInterviewCompleted && isResultPublished) {
        categories.completed.push(email);
      } else if (isInterviewCompleted && !isResultPublished) {
        categories.incomplete.push(email);
      } else if (!isInterviewCompleted && !isResultPublished) {
        categories.notStarted.push(email);
      }
    });

    return categories;
  };

  const getmails = async (type) => {
    if (type === "jobPost") {
      const applicants = RecuiterStore?.remainderMails;
      const categories = categorizeApplicants(applicants);
      console.log(categories);
      RecuiterStore.setCategories(categories);
    } else if (type === "interview") {
      const interviews = RecuiterStore?.remainderMails;
      const categories = categorizeInterviewApplicants(interviews);
      RecuiterStore.setCategories(categories);
    } else if (type === "resume") {
      const applicants = RecuiterStore?.remainderMails;
      const categories = categorizeResumeApplicants(applicants);

      RecuiterStore.setCategories(categories);
    }
  };

  // const getmails = async () => {
  //   let mails = [];
  //   let status = "";
  //   if (data.type === "interview") {
  //     switch (RecuiterStore.mailType) {
  //       case "Hired Candidates":
  //         status = "hired";
  //         break;
  //       case "Rejected candidates":
  //         status = "rejected";
  //         break;
  //       case "Short listed candidates":
  //         status = "hired";
  //         break;
  //       case "Assessment in-complete":
  //         status = "notStarted";

  //         break;
  //       case "Assessment Not-Started":
  //         status = "notStarted";
  //         break;
  //       case "Assessment Completed":
  //         status = "ALL";
  //         break;
  //       default:
  //         status = "ALL";
  //         break;
  //     }

  //     if (status === "ALL") {
  //       RecuiterStore.remainderMails.map((mail) => {
  //         mails.push(mail.interviewee.mail);
  //       });
  //     } else if (status === "notStarted") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.isInterviewCompleted === false) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else if (status === "hired") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 1) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else if (status === "rejected") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 2) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 0) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     }
  //   } else if (data.type === "jobPost") {
  //     switch (RecuiterStore.mailType) {
  //       case "Hired Candidates":
  //         status = "hired";
  //         break;
  //       case "Rejected candidates":
  //         status = "rejected";
  //         break;
  //       case "Short listed candidates":
  //         status = "hired";
  //         break;
  //       case "Assessment in-complete":
  //         status = "notStarted";

  //         break;
  //       case "Assessment Not-Started":
  //         status = "notStarted";
  //         break;
  //       case "Assessment Completed":
  //         status = "ALL";
  //         break;
  //       default:
  //         status = "ALL";
  //         break;
  //     }

  //     if (status === "ALL") {
  //       RecuiterStore.remainderMails.map((mail) => {
  //         mails.push(mail.interviewee.mail);
  //       });
  //     } else if (status === "notStarted") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.isInterviewCompleted === false) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else if (status === "hired") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 1) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else if (status === "rejected") {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 2) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     } else {
  //       RecuiterStore.remainderMails.filter((mail) => {
  //         if (mail.status === 0) {
  //           mails.push(mail.interviewee.mail);
  //         }
  //       });
  //     }
  //   }

  //   RecuiterStore.setReceiptentMails(mails);
  //   return mails;
  // };

  const emails = [
    "example1@example.com",
    "example2@example.com",
    "example3@example.com",
    "example4@example.com",
    "example5@example.com",
    "example6@example.com",
  ];

  const handleSendMail = () => {
    alert("Mail sent!");
  };
  const getPosition = () => {
    if (data?.type === "mockTest") {
      return data.mockTestName;
    }
    if (data?.type === "jobPost") {
      return data.jobTitle;
    }
    if (data?.type === "interview") {
      if (data.technology === "") {
        return "HR Interview";
      }
      return data.technology;
    }
  };

  const getassesments = (joppost) => {
    const assesments = [];
    const {
      mockTest,
      technicalInterview,
      hrInterview,
      assessment,
      codingInterview,
    } = joppost;
    if (mockTest) {
      assesments.push("MCQ's");
    }
    if (technicalInterview) {
      assesments.push("Technical Interview");
    }
    if (hrInterview) {
      assesments.push("HR Interview");
    }
    if (assessment || codingInterview) {
      assesments.push("Task");
    }

    return assesments;
  };

  const getTheAvailableRecordsInAllInvitations = (invitations, key) => {
    RecuiterStore.LoadedInvitations = [];

    invitations?.map((invitation) => {
      if (invitation.type === "jobPost") {
        if (invitation.jobTitle?.toLowerCase().includes(key.toLowerCase())) {
          RecuiterStore.LoadedInvitations.push(invitation);
        }
      }
      if (invitation.type === "interview") {
        if (invitation.technology?.toLowerCase().includes(key.toLowerCase())) {
          RecuiterStore.LoadedInvitations.push(invitation);
        }
      }
      if (invitation.type === "mockTest") {
        if (
          invitation.mockTestName?.toLowerCase().includes(key.toLowerCase())
        ) {
          RecuiterStore.LoadedInvitations.push(invitation);
        }
      }
      if (invitation.type === "resumeSorting") {
        if (invitation.name?.toLowerCase().includes(key.toLowerCase())) {
          RecuiterStore.LoadedInvitations.push(invitation);
        }
      }
    });
  };

  const filterJobPosts = (jobPosts, key) => {
    RecuiterStore.LoadedInvitations = [];
    jobPosts.map((job) => {
      if (job.jobTitle.toLowerCase().includes(key.toLowerCase())) {
        RecuiterStore.LoadedInvitations.push(job);
      }
    });
  };

  const filterInterviews = (interviews, key) => {
    RecuiterStore.LoadedInvitations = [];
    interviews.map((interview) => {
      if (interview.technology.toLowerCase().includes(key.toLowerCase())) {
        RecuiterStore.LoadedInvitations.push(interview);
      }
    });
  };

  const filterMcq = (mcqs, key) => {
    RecuiterStore.LoadedInvitations = [];
    mcqs.map((mcq) => {
      if (mcq.mockTestName.toLowerCase().includes(key.toLowerCase())) {
        RecuiterStore.LoadedInvitations.push(mcq);
      }
    });
  };

  const filterResume = (resumes, key) => {
    RecuiterStore.LoadedInvitations = [];
    resumes.map((resume) => {
      if (resume.name.toLowerCase().includes(key.toLowerCase())) {
        RecuiterStore.LoadedInvitations.push(resume);
      }
    });
  };

  return useObserver(() => (
    <>
      <InterviewPopup />
      <MailTypePopup
        handleNext={async () => {
          PopupStore.setMailTypePopup(false);
          await getmails();
          PopupStore.setMail(true);
        }}
      />
      {PopupStore.mail && (
        <MailPopup
          intialValue={PopupStore.mail}
          emails={RecuiterStore.receiptentMails}
          name="Shortilisted"
          sub={getSub(
            mails[RecuiterStore.mailTemplate]
              ? mails[RecuiterStore.mailTemplate]?.subject
              : "",
            {
              _Position_: getPosition(),
              _Company_Name_: JSON.parse(localStorage.getItem("user"))
                ?.companyName,
              _recruiter_email_: JSON.parse(localStorage.getItem("user"))?.mail,
              _contact_number_: JSON.parse(localStorage.getItem("user"))
                ?.mobile,
              _Name_: JSON.parse(localStorage.getItem("user"))?.name,

              _deadline_date_: Date.now(),
            }
          )}
          mess={getSub(
            mails[RecuiterStore.mailTemplate]
              ? mails[RecuiterStore.mailTemplate]?.body
              : "",
            {
              _Position_: getPosition(),
              _Company_Name_: JSON.parse(localStorage.getItem("user"))
                ?.companyName,
              _recruiter_email_: JSON.parse(localStorage.getItem("user"))?.mail,
              _contact_number_: JSON.parse(localStorage.getItem("user"))
                ?.mobile,
              _Name_: JSON.parse(localStorage.getItem("user"))?.name,

              _deadline_date_: Date.now(),
            }
          )}
          onSendMail={handleSendMail}
          onClose={() => PopupStore.setMailPopup(false)}
        />
      )}

      <div ref={top} className="w-[100%]  h-full  mt-6 ">
        <HelpCenter />

        <Loader loader={remainderLoader} />
        <div className="w-[93%] mx-auto mb-3">
          <ResponsiveHeader
            onblur={(e) => {
              if (e.target.value === "" && RecuiterStore.searchInitiated) {
                if (selectedButton === "All") {
                  RecuiterStore.fetchAllInvitations(true);
                }
                if (selectedButton === "job posts") {
                  RecuiterStore.fetchJobPostsForHistory(true);
                }
                if (selectedButton === "Interviews") {
                  RecuiterStore.fetchCompanyInvitations(true);
                }
                if (selectedButton === "Mcq") {
                  RecuiterStore.setHistoryMcqDataSearch("");
                  RecuiterStore.fetchmcqinvitation();
                }
                if (selectedButton === "Resume Analyzer") {
                  RecuiterStore.setHistoryResumeAnalyzerSearch("");
                  RecuiterStore.fetchjd();
                }
              }
            }}
            onKeyPress={async (e) => {
              if (e.key === "Enter") {
                RecuiterStore.searchInitiated = true;
                console.log(e.target.value);

                if (selectedButton === "All") {
                  // alert("need to integrate search functionality");
                  await getTheAvailableRecordsInAllInvitations(
                    RecuiterStore.allInvitations?.data,
                    e.target.value
                  );

                  RecuiterStore.setLoader(true);
                  const response = await apiGet(
                    `/recruiter/all-invitations/${
                      JSON.parse(localStorage.getItem("user"))?._id
                    }?skip=0&limit=10&clientId=${
                      RecuiterStore.clientId
                    }&searchFilter=${e.target.value}`
                  );
                  RecuiterStore.setLoader(false);

                  if (response.status === 200) {
                    console.log(response.body);
                    // RecuiterStore.setAllInvitations(response.body);
                    RecuiterStore.setInvitations(response.body);
                  }
                } else if (selectedButton === "job posts") {
                  await filterJobPosts(RecuiterStore.jobPosts, e.target.value);
                  RecuiterStore.setHistoryJobPostSearch(e.target.value);
                  // RecuiterStore.fetchJobPostsForHistory();
                  // RecuiterStore.setRecuirterJobPostSkip(page.selected * 10);
                  RecuiterStore.fetchJobPostsForHistory(true);
                } else if (selectedButton === "Interviews") {
                  await filterInterviews(
                    RecuiterStore.companyInvitations,
                    e.target.value
                  );
                  RecuiterStore.setHistoryInterviewSearch(e.target.value);
                  await RecuiterStore.fetchCompanyInvitations(true);
                  // alert("need to integrate search functionality");
                } else if (selectedButton === "Mcq") {
                  await filterMcq(RecuiterStore.mockTest, e.target.value);
                  RecuiterStore.setHistoryMcqDataSearch(e.target.value);
                  RecuiterStore.fetchmcqinvitation();
                } else if (selectedButton === "Resume Analyzer") {
                  await filterResume(RecuiterStore.jd, e.target.value);
                  RecuiterStore.setHistoryResumeAnalyzerSearch(e.target.value);
                  RecuiterStore.fetchjd();
                }
              }
            }}
            title={"Activity"}
            showButton={false}
            showDropdown={false}
          />
        </div>

        {/* <HeaderComponent tittle={"Activity"} /> */}
        <div className="w-[93%] mx-auto mb-10">
          {/* <Header title={"History"} /> */}
          {/* <HeaderComponent tittle={"Activity"} /> */}
          <Buttons
            Button={selectedButton}
            handleSelectedButton={handleSelectedButton}
            pag={pag}
          />

          {selectedButton === "All" &&
            (RecuiterStore.loader ? (
              <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Loop to create 5 divs */}
                {true &&
                  RecuiterStore.LoadedInvitations?.map((invitation) => {
                    // const minSalary = checkSalary(
                    //   invitation?.salary?.minimum ??
                    //     invitation?.salary?.exactAmount
                    // );
                    // const maxSalary = checkSalary(invitation?.salary?.maximum);
                    // const exactAmount = invitation?.salary?.exactAmount;
                    // const formattedSalary = invitation?.salary?.exactAmount
                    //   ? checkSalary(invitation?.salary?.exactAmount) +
                    //     " " +
                    //     invitation?.salary?.rate
                    //   : minSalary !== "N/A" && maxSalary !== "N/A"
                    //   ? `${minSalary} - ${
                    //       maxSalary + " " + invitation?.salary?.rate
                    //     }`
                    //   : "N/A";

                    // console.log(
                    //   minSalary,
                    //   maxSalary,
                    //   formattedSalary,
                    //   invitation.technology,

                    //   "meghana"
                    // );
                    console.log(toJS(RecuiterStore.jobPosts), "sai2");
                    // const minSalary = checkSalary(job?.salary?.minimum);
                    // const maxSalary = checkSalary(job?.salary?.maximum);
                    const currency = invitation?.salary?.currency?.includes(
                      "UGX"
                    )
                      ? "UGX"
                      : invitation?.salary?.currency?.split(" ")[0] ?? "₹";
                    const minSalary = checkSalary(
                      currency,
                      invitation?.salary?.minimum
                    );
                    const maxSalary = checkSalary(
                      currency,
                      invitation?.salary?.maximum
                    );
                    // const formattedSalary = invitation?.salary?.exactAmount
                    //   ? checkSalary(currency, invitation?.salary?.exactAmount) +
                    //     " " +
                    //     invitation?.salary?.rate
                    //   : (minSalary !== "N/A" && maxSalary !== "N/A")
                    //   ? `${minSalary} - ${maxSalary}`
                    //   : (minSalary || maxSalary || "N/A");

                    const formattedSalary = (job) => {
                      if (invitation?.salary?.isSalaryDisclosed === false) {
                        return "Unpaid";
                      }
                      const minSalary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.minimum
                      );
                      const maxSalary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.maximum
                      );

                      const salary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.exactAmount ??
                          invitation?.salary?.minimum
                      );
                      // function formatSalary() {
                      const formattedSalary =
                        minSalary !== "N/A" && maxSalary !== "N/A"
                          ? `${minSalary} - ${maxSalary} ` +
                            invitation?.salary?.rate?.replace("per", "")
                          : salary +
                            "/" +
                            (invitation?.salary?.rate === "perYear"
                              ? "Year"
                              : invitation?.salary?.rate === "perMonth"
                              ? "Month"
                              : invitation?.salary?.rate === "perDay"
                              ? "Day"
                              : invitation?.salary?.rate === "perHour"
                              ? "Hour"
                              : "");

                      return formattedSalary;
                    };

                    return (
                      <>
                        {invitation.type === "interview" && (
                          <HistoryJobpostCard
                            onClick={async (action) => {
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "interview"
                              );
                              setRemainderLoader(false);
                              await getmails("interview");
                              RecuiterStore.setRemainderMailType("interview");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            cardType={"interviewCard"}
                            label={
                              invitation.technology !== ""
                                ? invitation.technology
                                : "HR Interview"
                            }
                            totalApplicants={invitation?.applicantsCount}
                            job={invitation}
                            rejected={invitation?.rejected?.length}
                            shortlisted={invitation?.shortListed?.length}
                            hired={invitation?.hired?.length}
                            hold={
                              invitation?.applicantsCount -
                              invitation?.rejected?.length -
                              invitation?.shortListed?.length
                            }
                            labels={invitation?.labels}
                            id={invitation?._id}
                            interviewType={invitation.interviewType}
                            interviewLevel={invitation.levelOfInterview}
                            questions={invitation.allQuestions}
                            status={invitation?.isOpen}
                            postedOn={formatDate(invitation?.createdAt)}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem(
                                  "interviewId",
                                  invitation._id
                                );
                                RecuiterStore.setApplicantSkip(0);
                                RecuiterStore.setInterviewApplicants([]);
                                navigate(`/company/applicants`);
                              } else {
                                alert("No applicants found");
                              }
                            }}
                            verifiedStatus={null}
                          />
                        )}

                        {invitation.type === "jobPost" && (
                          // <JobCard
                          //   client={invitation?.client?.name}
                          //   type="jobPost"
                          //   date={true}
                          //   id={invitation?._id}
                          //   title={invitation?.jobTitle}
                          //   postedOn={formatDate(invitation?.createdAt)}
                          //   salary={formattedSalary()}
                          //   experience={`${invitation?.requiredExperience?.minimum} - ${invitation?.requiredExperience?.maximum}`}
                          //   location={invitation?.jobLocation}
                          //   details={invitation?.jobMode}
                          //   labels={invitation?.labels}
                          //   workMode={handleMode(invitation?.workMode)}
                          //   openings={invitation?.noOfOpenings}
                          //   status={invitation?.isOpen}
                          //   buttonName={"job"}
                          //   job={invitation}
                          //   shortlisted={invitation?.shortListed?.length || 0}
                          //   createdAt={timestampToDate(invitation?.createdAt)}
                          //   handleClick={() => {
                          //     localStorage.setItem("jobId", invitation?._id);

                          //     navigate(
                          //       `/company/job-applicants/${invitation?._id}`
                          //     );
                          //   }}
                          //   attempted={invitation?.applicantsCount || 0}
                          // />
                          <HistoryJobpostCard
                            cardType={"jobPostCard"}
                            // label="UI UX Designer"
                            buttonLabels={getassesments(invitation)}
                            job={invitation}
                            label={invitation?.jobTitle}
                            status={invitation?.isOpen}
                            labels={invitation?.labels}
                            id={invitation?._id}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length}
                            shortlisted={invitation?.shortListed?.length}
                            hired={invitation?.hired?.length}
                            hold={
                              invitation?.applicantsCount -
                              invitation?.rejected?.length -
                              invitation?.shortListed?.length
                            }
                            postedOn={formatDate?.(invitation?.createdAt)}
                            workMode={handleMode?.(invitation?.workMode)}
                            experience={`${invitation?.requiredExperience?.minimum} - ${invitation?.requiredExperience?.maximum}`}
                            salary={
                              invitation?.salary?.isSalaryDisclosed === false
                                ? "Unpaid"
                                : formattedSalary()
                            }
                            verifiedStatus={invitation?.verifiedStatus}
                            onClick={async (action) => {
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "jobPost"
                              );
                              setRemainderLoader(false);
                              await getmails("jobPost");
                              RecuiterStore.setRemainderMailType("jobPost");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem("jobId", invitation?._id);
                                navigate(
                                  `/company/job-applicants/${invitation?._id}`
                                );
                              } else {
                                alert("No applicants found");
                              }
                            }}
                          />
                        )}
                        {invitation.type === "mockTest" && (
                          // <JobCard
                          //   key={invitation._id}
                          //   client={invitation?.client?.name}
                          //   type="mockTest"
                          //   date={true}
                          //   id={invitation._id}
                          //   attempted={invitation?.mockTestInvites?.length}
                          // title={
                          //   invitation.mockTestName !== ""
                          //     ? invitation.mockTestName
                          //     : ""
                          // }
                          //   shortlisted={"-"}
                          //   technical={invitation?.noOfTechnicalQuestions}
                          //   aptitude={invitation?.noOfAptitudeQuestions}
                          //   reasoning={invitation?.noOfReasoningQuestions}
                          //   verbal={invitation?.noOfVerbalQuestions}
                          //   postedOn={formatDate(invitation.createdAt)}
                          //   cutOff={invitation.cutOff}
                          //   questions={invitation.noOfQuestions}
                          //   status={invitation?.isOpen}
                          //   buttonName={"MCQ"}
                          //   createdAt={timestampToDate(invitation?.createdAt)}
                          //   job={invitation}
                          //   handleClick={() => {
                          //     localStorage.setItem(
                          //       "interviewId",
                          //       invitation?._id
                          //     );
                          //     RecuiterStore.setApplicantSkip(0);
                          //     navigate(
                          //       `/company/mocktest-applicants?mocktestId=${invitation._id}`
                          //     );
                          //   }}
                          // />
                          <HistoryJobpostCard
                            onClick={async (action) => {
                              console.log(action, "action");
                              // alert("Commig soon...");
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "mockTest"
                              );
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            job={invitation}
                            label={
                              invitation.mockTestName !== ""
                                ? invitation.mockTestName
                                : ""
                            }
                            cardType={"mcqCard"}
                            buttonLabels={[
                              `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                              `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                              `Technical: ${invitation?.noOfTechnicalQuestions}`,
                              `verbal: ${invitation?.noOfVerbalQuestions}`,
                            ]}
                            id={invitation?._id}
                            postedOn={formatDate(invitation.createdAt)}
                            cutOff={invitation.cutOff}
                            questions={invitation.noOfQuestions}
                            verifiedStatus={null}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length ?? "-"}
                            shortlisted={invitation?.shortListed?.length ?? "-"}
                            hired={invitation?.hired?.length ?? "-"}
                            hold={
                              invitation?.applicantsCount -
                                invitation?.rejected?.length -
                                invitation?.shortListed?.length ?? "-"
                            }
                            status={invitation?.isOpen}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem(
                                  "interviewId",
                                  invitation?._id
                                );
                                RecuiterStore.setApplicantSkip(0);
                                navigate(
                                  `/company/mocktest-applicants?mocktestId=${invitation._id}`
                                );
                              } else {
                                alert("No applicants found");
                              }
                            }}
                          />
                        )}
                        {invitation.type === "resumeSorting" && (
                          <HistoryJobpostCard
                            onClick={async (action) => {
                              console.log(action, "action");
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "resumeSorting"
                              );
                              setRemainderLoader(false);
                              await getmails("resume");
                              RecuiterStore.setRemainderMailType("resume");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            job={invitation}
                            label={
                              invitation.mockTestName !== ""
                                ? invitation.mockTestName
                                : ""
                            }
                            cardType={"resumeCard"}
                            buttonLabels={[
                              `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                              `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                              `Technical: ${invitation?.noOfTechnicalQuestions}`,
                              `verbal: ${invitation?.noOfVerbalQuestions}`,
                            ]}
                            id={invitation?._id}
                            verifiedStatus={null}
                            postedOn={formatDate(invitation.createdAt)}
                            cutOff={invitation.cutOff}
                            questions={invitation.noOfQuestions}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length ?? "-"}
                            shortlisted={invitation?.shortListed?.length ?? "-"}
                            hired={invitation?.hired?.length ?? "-"}
                            hold={
                              invitation?.applicantsCount -
                                invitation?.rejected?.length -
                                invitation?.shortListed?.length ?? "-"
                            }
                            status={invitation?.isOpen}
                            handleNavigation={() => {
                              if (invitation?.resumes?.length > 0) {
                                navigate(
                                  `/company/resumescore/${invitation._id}${
                                    invitation?.isSortingCompleted
                                      ? ""
                                      : "?save=true"
                                  }`
                                );
                              } else {
                                alert("No Resumes found");
                              }
                            }}
                          />
                        )}
                      </>
                    );
                  })}
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl shadow-lg shadow-gray-300 animate-pulse bg-gray-100 mt-[1rem]"
                  >
                    <div className="history-page flex  w-full p-2 ">
                      {/* <div className="w-[50%] one border-r-2">
                        <LoadingAnime
                          mainBoxWidth="100%"
                          numBoxes={1} // Correct usage of equal sign to pass a number
                          boxWidth="38vw" // Use equal sign for strings
                          gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
                          bgColor="bg-transparent"
                          useShadow={false} // String prop
                          innerBoxes={[
                            //first text
                            {
                              width: "50%",
                              height: "40%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              left: "0.3rem",
                            },
                            //salary
                            {
                              width: "30%",
                              height: "25%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "2.7rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "35%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "4.5rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "25%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "6.0rem",
                              left: "0.3rem",
                            },
                            {
                              width: "35%",
                              height: "30%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "-0.5rem",
                              left: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "-0.5rem",
                              right: "2rem",
                            },
                          ]}
                        />
                      </div> */}

                      {/* <div className="two w-[50%]">
                        <LoadingAnime
                          mainBoxWidth="100%"
                          numBoxes={1} // Correct usage of equal sign to pass a number
                          boxWidth="38vw" // Use equal sign for strings
                          gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
                          bgColor="bg-transparent"
                          useShadow={false} // String prop
                          innerBoxes={[
                            //logo
                            {
                              width: "25%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape:"rectangle",
                              top: "0rem",
                              left: "0.3rem",

                            },
                            //first text
                            {
                              width: "25%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              right: "0.3rem",
                            },
                            //salary
                            {
                              width: "40%",
                              height: "50%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "3rem",
                              left: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "0rem",
                              left: "0.3rem",
                            },
                            {
                              width: "40%",
                              height: "50%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "3rem",
                              right: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "0rem",
                              right: "0.3rem",
                            },
                          ]}
                        />
                      </div> */}
                      <div className="flex  gap-x-4">
                        {/* Logo */}
                        <div className="w-32 ml-2 h-32 bg-gray-200 rounded-full"></div>

                        {/* Job Info */}
                        <div className="flex-1 space-y-2 mt-4">
                          <div className="w-52 h-6 bg-gray-200 rounded"></div>
                          <div className="w-48 h-3 bg-gray-200 rounded"></div>
                          <div className="w-44 h-3 bg-gray-200 rounded"></div>
                          <div className="w-40 h-3 bg-gray-200 rounded"></div>
                        </div>

                        {/* Buttons */}
                        <div className="  flex ml-32  gap-2 ">
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                        </div>
                      </div>

                      {/* Job Details Section */}
                      <div className="mt-32 flex gap-2 -ml-[41rem]">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                      </div>

                      {/* Application Stats */}
                      <div className=" flex  gap-2 ml-[45rem] mb-20">
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                      </div>
                      <div className="w-32 h-6 mt-24 -ml-28 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {RecuiterStore.allInvitations?.data?.length === 0 && (
                  <div className="flex items-center justify-center text-xl text-primary font-bold h-[50vh]">
                    {" "}
                    Create any job post , interview or mcq to view here
                  </div>
                )}
                {true &&
                  RecuiterStore.allInvitations?.data?.map((invitation) => {
                    // const minSalary = checkSalary(
                    //   invitation?.salary?.minimum ??
                    //     invitation?.salary?.exactAmount
                    // );
                    // const maxSalary = checkSalary(invitation?.salary?.maximum);
                    // const exactAmount = invitation?.salary?.exactAmount;
                    // const formattedSalary = invitation?.salary?.exactAmount
                    //   ? checkSalary(invitation?.salary?.exactAmount) +
                    //     " " +
                    //     invitation?.salary?.rate
                    //   : minSalary !== "N/A" && maxSalary !== "N/A"
                    //   ? `${minSalary} - ${
                    //       maxSalary + " " + invitation?.salary?.rate
                    //     }`
                    //   : "N/A";

                    // console.log(
                    //   minSalary,
                    //   maxSalary,
                    //   formattedSalary,
                    //   invitation.technology,

                    //   "meghana"
                    // );
                    console.log(toJS(RecuiterStore.jobPosts), "sai2");
                    // const minSalary = checkSalary(job?.salary?.minimum);
                    // const maxSalary = checkSalary(job?.salary?.maximum);
                    const currency = invitation?.salary?.currency?.includes(
                      "UGX"
                    )
                      ? "UGX"
                      : invitation?.salary?.currency?.split(" ")[0] ?? "₹";
                    const minSalary = checkSalary(
                      currency,
                      invitation?.salary?.minimum
                    );
                    const maxSalary = checkSalary(
                      currency,
                      invitation?.salary?.maximum
                    );
                    // const formattedSalary = invitation?.salary?.exactAmount
                    //   ? checkSalary(currency, invitation?.salary?.exactAmount) +
                    //     " " +
                    //     invitation?.salary?.rate
                    //   : (minSalary !== "N/A" && maxSalary !== "N/A")
                    //   ? `${minSalary} - ${maxSalary}`
                    //   : (minSalary || maxSalary || "N/A");

                    const formattedSalary = (job) => {
                      const minSalary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.minimum
                      );
                      const maxSalary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.maximum
                      );

                      const salary = checkSalary(
                        invitation?.salary?.currency?.includes("UGX")
                          ? "UGX"
                          : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                        invitation?.salary?.exactAmount ??
                          invitation?.salary?.minimum
                      );
                      // function formatSalary() {
                      const formattedSalary =
                        minSalary !== "N/A" && maxSalary !== "N/A"
                          ? `${minSalary} - ${maxSalary} ` +
                            invitation?.salary?.rate?.replace("per", "")
                          : salary +
                            "/" +
                            (invitation?.salary?.rate === "perYear"
                              ? "Year"
                              : invitation?.salary?.rate === "perMonth"
                              ? "Month"
                              : invitation?.salary?.rate === "perDay"
                              ? "Day"
                              : invitation?.salary?.rate === "perHour"
                              ? "Hour"
                              : "");

                      return formattedSalary;
                    };

                    return (
                      <>
                        {invitation.type === "interview" && (
                          <HistoryJobpostCard
                            onClick={async (action) => {
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "interview"
                              );
                              setRemainderLoader(false);
                              await getmails("interview");
                              RecuiterStore.setRemainderMailType("interview");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            cardType={"interviewCard"}
                            label={
                              invitation.technology !== ""
                                ? invitation.technology
                                : "HR Interview"
                            }
                            totalApplicants={invitation?.applicantsCount}
                            job={invitation}
                            rejected={invitation?.rejected?.length}
                            hired={invitation?.shortListed?.length}
                            hold={
                              invitation?.applicantsCount -
                              invitation?.rejected?.length -
                              invitation?.shortListed?.length
                            }
                            labels={invitation?.labels}
                            id={invitation?._id}
                            interviewType={invitation.interviewType}
                            interviewLevel={invitation.levelOfInterview}
                            questions={invitation.allQuestions}
                            status={invitation?.isOpen}
                            postedOn={formatDate(invitation?.createdAt)}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem(
                                  "interviewId",
                                  invitation._id
                                );
                                RecuiterStore.setApplicantSkip(0);
                                RecuiterStore.setInterviewApplicants([]);
                                navigate(`/company/applicants`);
                              } else {
                                alert("No applicants found");
                              }
                            }}
                            verifiedStatus={null}
                          />
                        )}

                        {invitation.type === "jobPost" && (
                          <HistoryJobpostCard
                            verifiedStatus={invitation?.verifiedStatus}
                            cardType={"jobPostCard"}
                            // label="UI UX Designer"
                            buttonLabels={getassesments(invitation)}
                            job={invitation}
                            label={invitation?.jobTitle}
                            status={invitation?.isOpen}
                            labels={invitation?.labels}
                            id={invitation?._id}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length}
                            hired={invitation?.shortListed?.length}
                            hold={
                              invitation?.applicantsCount -
                              invitation?.rejected?.length -
                              invitation?.shortListed?.length
                            }
                            postedOn={formatDate?.(invitation?.createdAt)}
                            workMode={handleMode?.(invitation?.workMode)}
                            experience={`${invitation?.requiredExperience?.minimum} - ${invitation?.requiredExperience?.maximum}`}
                            salary={
                              invitation?.salary?.isSalaryDisclosed === false
                                ? "Unpaid"
                                : formattedSalary()
                            }
                            onClick={async (action) => {
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "jobPost"
                              );
                              setRemainderLoader(false);
                              await getmails("jobPost");
                              RecuiterStore.setRemainderMailType("jobPost");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem("jobId", invitation?._id);
                                navigate(
                                  `/company/job-applicants/${invitation?._id}`
                                );
                              } else {
                                alert("No applicants found");
                              }
                            }}
                          />
                        )}
                        {invitation.type === "mockTest" && (
                          <HistoryJobpostCard
                            verifiedStatus={null}
                            onClick={async (action) => {
                              console.log(action, "action");
                              // alert("Commig soon...");
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "mockTest"
                              );
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            job={invitation}
                            label={
                              invitation.mockTestName !== ""
                                ? invitation.mockTestName
                                : ""
                            }
                            cardType={"mcqCard"}
                            buttonLabels={[
                              `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                              `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                              `Technical: ${invitation?.noOfTechnicalQuestions}`,
                              `verbal: ${invitation?.noOfVerbalQuestions}`,
                            ]}
                            id={invitation?._id}
                            postedOn={formatDate(invitation.createdAt)}
                            cutOff={invitation.cutOff}
                            questions={invitation.noOfQuestions}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length ?? "-"}
                            hired={invitation?.shortListed?.length ?? "-"}
                            hold={
                              invitation?.applicantsCount -
                                invitation?.rejected?.length -
                                invitation?.shortListed?.length ?? "-"
                            }
                            status={invitation?.isOpen}
                            handleNavigation={() => {
                              if (invitation?.applicantsCount > 0) {
                                localStorage.setItem(
                                  "interviewId",
                                  invitation?._id
                                );
                                RecuiterStore.setApplicantSkip(0);
                                navigate(
                                  `/company/mocktest-applicants?mocktestId=${invitation._id}`
                                );
                              } else {
                                alert("No applicants found");
                              }
                            }}
                          />
                        )}
                        {invitation.type === "resumeSorting" && (
                          <HistoryJobpostCard
                            verifiedStatus={null}
                            onClick={async (action) => {
                              console.log(action, "action");
                              setRemainderLoader(true);
                              await RecuiterStore.fetchRemainderMails(
                                invitation._id,
                                "resumeSorting"
                              );
                              setRemainderLoader(false);
                              await getmails("resume");
                              RecuiterStore.setRemainderMailType("resume");
                              RecuiterStore.setMailType("");
                              RecuiterStore.setMailTemplate("");
                              setData(invitation);
                              PopupStore.setMailTypePopup(true);
                            }}
                            job={invitation}
                            label={
                              invitation.mockTestName !== ""
                                ? invitation.mockTestName
                                : ""
                            }
                            cardType={"resumeCard"}
                            buttonLabels={[
                              `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                              `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                              `Technical: ${invitation?.noOfTechnicalQuestions}`,
                              `verbal: ${invitation?.noOfVerbalQuestions}`,
                            ]}
                            id={invitation?._id}
                            postedOn={formatDate(invitation.createdAt)}
                            cutOff={invitation.cutOff}
                            questions={invitation.noOfQuestions}
                            totalApplicants={invitation?.applicantsCount}
                            rejected={invitation?.rejected?.length ?? "-"}
                            shortlisted={invitation?.shortListed?.length ?? "-"}
                            hired={invitation?.hired?.length ?? "-"}
                            hold={
                              invitation?.applicantsCount -
                                invitation?.rejected?.length -
                                invitation?.shortListed?.length ?? "-"
                            }
                            status={invitation?.isOpen}
                            handleNavigation={() => {
                              if (invitation?.resumes?.length > 0) {
                                navigate(
                                  `/company/resumescore/${invitation._id}${
                                    invitation?.isSortingCompleted
                                      ? ""
                                      : "?save=true"
                                  }`
                                );
                              } else {
                                alert("No Resumes found");
                              }
                            }}
                          />
                        )}
                      </>
                    );
                  })}
              </>
            ))}
          {selectedButton === "job posts" &&
            (RecuiterStore.loader ? (
              <div className="grid grid-cols-1 sm:grid-cols-1  lg:grid-cols-1 gap-4">
                {/* Loop to create 5 divs */}
                {RecuiterStore.LoadedInvitations.map((invitation) => {
                  const currency = invitation?.salary?.currency?.includes("UGX")
                    ? "UGX"
                    : invitation?.salary?.currency?.split(" ")[0] ?? "₹";
                  const minSalary = checkSalary(
                    currency,
                    invitation?.salary?.minimum
                  );
                  const maxSalary = checkSalary(
                    currency,
                    invitation?.salary?.maximum
                  );

                  const formattedSalary = (invitation) => {
                    const minSalary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.minimum
                    );
                    const maxSalary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.maximum
                    );

                    const salary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.exactAmount ??
                        invitation?.salary?.minimum
                    );
                    // function formatSalary() {
                    const formattedSalary =
                      minSalary !== "N/A" && maxSalary !== "N/A"
                        ? `${minSalary} - ${maxSalary} ` +
                          invitation?.salary?.rate?.replace("per", "")
                        : salary +
                          " " +
                          (invitation?.salary?.rate === "perYear"
                            ? "Year"
                            : invitation?.salary?.rate === "perMonth"
                            ? "Month"
                            : invitation?.salary?.rate === "perDay"
                            ? "Day"
                            : invitation?.salary?.rate === "perHour"
                            ? "Hour"
                            : "");

                    return formattedSalary;
                  };

                  return (
                    <HistoryJobpostCard
                      verifiedStatus={invitation?.verifiedStatus}
                      cardType={"jobPostCard"}
                      // label="UI UX Designer"
                      buttonLabels={getassesments(invitation)}
                      job={invitation}
                      label={invitation?.jobTitle}
                      status={invitation?.isOpen}
                      labels={invitation?.labels}
                      id={invitation?._id}
                      totalApplicants={invitation?.applicantsCount}
                      rejected={invitation?.rejected?.length}
                      hired={invitation?.shortListed?.length}
                      hold={
                        invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length
                      }
                      postedOn={formatDate?.(invitation?.createdAt)}
                      workMode={handleMode?.(invitation?.workMode)}
                      experience={`${invitation?.requiredExperience?.minimum} - ${invitation?.requiredExperience?.maximum}`}
                      salary={formattedSalary(invitation)}
                      onClick={async (action) => {
                        setRemainderLoader(true);
                        await RecuiterStore.fetchRemainderMails(
                          invitation._id,
                          "jobPost"
                        );
                        setRemainderLoader(false);
                        await getmails("jobPost");
                        RecuiterStore.setRemainderMailType("jobPost");
                        RecuiterStore.setMailType("");
                        RecuiterStore.setMailTemplate("");
                        setData(invitation);
                        PopupStore.setMailTypePopup(true);
                      }}
                      handleNavigation={() => {
                        if (invitation?.applicantsCount > 0) {
                          localStorage.setItem("jobId", invitation?._id);
                          navigate(
                            `/company/job-applicants/${invitation?._id}`
                          );
                        } else {
                          alert("No applicants found");
                        }
                      }}
                    />
                  );
                })}
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl shadow-lg shadow-gray-300  animate-pulse bg-gray-100 mt-[1rem]"
                  >
                    <div className="history-page flex items-center  w-full p-2">
                      <div className="flex  gap-x-4">
                        {/* Logo */}
                        <div className="w-32 ml-2 h-32 bg-gray-200 rounded-full"></div>

                        {/* Job Info */}
                        <div className="flex-1 space-y-2 mt-4">
                          <div className="w-52 h-6 bg-gray-200 rounded"></div>
                          <div className="w-48 h-3 bg-gray-200 rounded"></div>
                          <div className="w-44 h-3 bg-gray-200 rounded"></div>
                          <div className="w-40 h-3 bg-gray-200 rounded"></div>
                        </div>

                        {/* Buttons */}
                        {/* <div className="  flex ml-32  gap-2 "> 
                           <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                        </div> */}
                      </div>

                      {/* Job Details Section */}
                      <div className="mt-32 flex gap-2 -ml-[41rem]">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                      </div>

                      {/* Application Stats */}
                      <div className=" flex  gap-2 ml-auto mb-20">
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                      </div>
                      <div className="w-32 h-6 mt-24 -ml-28 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {RecuiterStore.jobPosts.length === 0 && !remainderLoader && (
                  <div className="flex items-center justify-center text-xl text-primary font-bold h-[50vh]">
                    {" "}
                    Create a job post to view here
                  </div>
                )}
                {RecuiterStore.jobPosts.map((invitation) => {
                  console.log(toJS(RecuiterStore.jobPosts), "sai2");
                  const currency = invitation?.salary?.currency?.includes("UGX")
                    ? "UGX"
                    : invitation?.salary?.currency?.split(" ")[0] ?? "₹";
                  const minSalary = checkSalary(
                    currency,
                    invitation?.salary?.minimum
                  );
                  const maxSalary = checkSalary(
                    currency,
                    invitation?.salary?.maximum
                  );
                  // const formattedSalary = job?.salary?.exactAmount
                  //   ? checkSalary(currency, job?.salary?.exactAmount) +
                  //     " " +
                  //     job?.salary?.rate
                  //   : (minSalary !== "N/A" && maxSalary !== "N/A")
                  //   ? `${minSalary} - ${maxSalary}`
                  //   : (minSalary || maxSalary || "N/A");
                  const formattedSalary = (invitation) => {
                    // const minSalary = checkSalary(jobData?.salary?.minimum);
                    // const maxSalary = checkSalary(job?.salary?.maximum);

                    // const salary = checkSalary(job?.salary?.exactAmount);
                    // const formattedSalary =
                    //   minSalary !== "N/A" && maxSalary !== "N/A"
                    //     ? job?.salary?.currency?.split[0] ??
                    //       "₹" + " " + `${minSalary} - ${maxSalary} ` + job?.salary?.rate
                    //     : job?.salary?.currency?.split[0] ??
                    //       "₹" + " " + salary + " " + job?.salary?.rate;

                    const minSalary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.minimum
                    );
                    const maxSalary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.maximum
                    );

                    const salary = checkSalary(
                      invitation?.salary?.currency?.includes("UGX")
                        ? "UGX"
                        : invitation?.salary?.currency?.split(" ")[0] ?? "₹",
                      invitation?.salary?.exactAmount ??
                        invitation?.salary?.minimum
                    );
                    // function formatSalary() {
                    const formattedSalary =
                      minSalary !== "N/A" && maxSalary !== "N/A"
                        ? `${minSalary} - ${maxSalary} ` +
                          invitation?.salary?.rate?.replace("per", "")
                        : salary +
                          " " +
                          (invitation?.salary?.rate === "perYear"
                            ? "Year"
                            : invitation?.salary?.rate === "perMonth"
                            ? "Month"
                            : invitation?.salary?.rate === "perDay"
                            ? "Day"
                            : invitation?.salary?.rate === "perHour"
                            ? "Hour"
                            : "");

                    return formattedSalary;
                  };

                  return (
                    <HistoryJobpostCard
                      verifiedStatus={invitation?.verifiedStatus}
                      cardType={"jobPostCard"}
                      // label="UI UX Designer"
                      buttonLabels={getassesments(invitation)}
                      job={invitation}
                      label={invitation?.jobTitle}
                      status={invitation?.isOpen}
                      labels={invitation?.labels}
                      id={invitation?._id}
                      totalApplicants={invitation?.applicantsCount}
                      rejected={invitation?.rejected?.length}
                      hired={invitation?.shortListed?.length}
                      hold={
                        invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length
                      }
                      postedOn={formatDate?.(invitation?.createdAt)}
                      workMode={handleMode?.(invitation?.workMode)}
                      experience={`${invitation?.requiredExperience?.minimum} - ${invitation?.requiredExperience?.maximum}`}
                      salary={
                        invitation?.salary?.isSalaryDisclosed === false
                          ? "Unpaid"
                          : formattedSalary(invitation)
                      }
                      onClick={async (action) => {
                        setRemainderLoader(true);
                        await RecuiterStore.fetchRemainderMails(
                          invitation._id,
                          "jobPost"
                        );
                        setRemainderLoader(false);
                        await getmails("jobPost");
                        RecuiterStore.setRemainderMailType("jobPost");
                        RecuiterStore.setMailType("");
                        RecuiterStore.setMailTemplate("");
                        setData(invitation);
                        PopupStore.setMailTypePopup(true);
                      }}
                      handleNavigation={() => {
                        if (invitation?.applicantsCount > 0) {
                          localStorage.setItem("jobId", invitation?._id);
                          navigate(
                            `/company/job-applicants/${invitation?._id}`
                          );
                        } else {
                          alert("No applicants found");
                        }
                      }}
                    />
                  );
                })}
              </>
            ))}
          {selectedButton === "Interviews" &&
            (RecuiterStore.loader ? (
              <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Loop to loaded Invitations */}
                {RecuiterStore.LoadedInvitations.map((invitation) => (
                  <HistoryJobpostCard
                    verifiedStatus={null}
                    onClick={async (action) => {
                      setRemainderLoader(true);
                      await RecuiterStore.fetchRemainderMails(
                        invitation._id,
                        "interview"
                      );
                      setRemainderLoader(false);
                      await getmails("interview");
                      RecuiterStore.setRemainderMailType("interview");
                      RecuiterStore.setMailType("");
                      RecuiterStore.setMailTemplate("");
                      setData(invitation);
                      PopupStore.setMailTypePopup(true);
                    }}
                    cardType={"interviewCard"}
                    label={
                      invitation.technology !== ""
                        ? invitation.technology
                        : "HR Interview"
                    }
                    totalApplicants={invitation?.interviews?.length}
                    job={invitation}
                    rejected={invitation?.rejected?.length}
                    shortlisted={invitation?.shortListed?.length}
                    hired={invitation?.hired?.length}
                    hold={
                      invitation?.applicantsCount -
                      invitation?.rejected?.length -
                      invitation?.shortListed?.length
                    }
                    labels={invitation?.labels}
                    id={invitation?._id}
                    interviewType={invitation.interviewType}
                    interviewLevel={invitation.levelOfInterview}
                    questions={invitation.allQuestions}
                    status={invitation?.isOpen}
                    postedOn={formatDate(invitation?.createdAt)}
                    handleNavigation={() => {
                      if (invitation?.interviews?.length > 0) {
                        localStorage.setItem("interviewId", invitation._id);
                        RecuiterStore.setApplicantSkip(0);
                        RecuiterStore.setInterviewApplicants([]);
                        navigate(`/company/applicants`);
                      } else {
                        alert("No applicants found");
                      }
                    }}
                  />
                ))}
                {/* Loop to create 5 divs */}
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl shadow-lg shadow-gray-300 animate-pulse bg-gray-100 mt-[1rem]"
                  >
                    <div className="history-page flex items-center w-full p-2">
                      <div className="w-[50%] one border-r-2">
                        <LoadingAnime
                          mainBoxWidth="100%"
                          numBoxes={1} // Correct usage of equal sign to pass a number
                          boxWidth="38vw" // Use equal sign for strings
                          gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
                          bgColor="bg-transparent"
                          useShadow={false} // String prop
                          innerBoxes={[
                            //first text
                            {
                              width: "50%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              left: "0.3rem",
                            },
                            //salary
                            {
                              width: "30%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "2.7rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "4.5rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "6.2rem",
                              left: "0.3rem",
                            },
                            {
                              width: "35%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "-0.5rem",
                              left: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "-0.5rem",
                              right: "2rem",
                            },
                          ]}
                        />
                      </div>

                      <div className="two w-[50%]">
                        <LoadingAnime
                          mainBoxWidth="100%"
                          numBoxes={1} // Correct usage of equal sign to pass a number
                          boxWidth="38vw" // Use equal sign for strings
                          gridColumns="grid-cols-1 sm:grid-cols-1 lg:grid-cols-1" // Correct string prop passing
                          bgColor="bg-transparent"
                          useShadow={false} // String prop
                          innerBoxes={[
                            //first text
                            {
                              width: "25%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              left: "0.3rem",
                            },
                            {
                              width: "30%",
                              height: "20%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "0rem",
                              right: "0.3rem",
                            },
                            //salary
                            {
                              width: "40%",
                              height: "50%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "3rem",
                              left: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "0rem",
                              left: "0.3rem",
                            },
                            {
                              width: "40%",
                              height: "50%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              top: "3rem",
                              right: "0.3rem",
                            },
                            {
                              width: "20%",
                              height: "15%",
                              color: "bg-gray-400",
                              shape: "rectangle",
                              bottom: "0rem",
                              right: "0.3rem",
                            },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                <>
                  {RecuiterStore.companyInvitations.length === 0 && (
                    <div className="flex items-center justify-center text-xl text-primary font-bold h-[50vh]">
                      {" "}
                      Create an interview to view
                    </div>
                  )}
                  {RecuiterStore.companyInvitations.map((invitation) => (
                    <HistoryJobpostCard
                      verifiedStatus={null}
                      onClick={async (action) => {
                        setRemainderLoader(true);
                        await RecuiterStore.fetchRemainderMails(
                          invitation._id,
                          "interview"
                        );
                        setRemainderLoader(false);
                        await getmails("interview");
                        RecuiterStore.setRemainderMailType("interview");
                        RecuiterStore.setMailType("");
                        RecuiterStore.setMailTemplate("");
                        setData(invitation);
                        PopupStore.setMailTypePopup(true);
                      }}
                      cardType={"interviewCard"}
                      label={
                        invitation.technology !== ""
                          ? invitation.technology
                          : "HR Interview"
                      }
                      totalApplicants={invitation?.interviews?.length}
                      job={invitation}
                      rejected={invitation?.rejected?.length}
                      hired={invitation?.shortListed?.length}
                      hold={
                        invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length
                      }
                      labels={invitation?.labels}
                      id={invitation?._id}
                      interviewType={invitation.interviewType}
                      interviewLevel={invitation.levelOfInterview}
                      questions={invitation.allQuestions}
                      status={invitation?.isOpen}
                      postedOn={formatDate(invitation?.createdAt)}
                      handleNavigation={() => {
                        if (invitation?.interviews?.length > 0) {
                          localStorage.setItem("interviewId", invitation._id);
                          RecuiterStore.setApplicantSkip(0);
                          RecuiterStore.setInterviewApplicants([]);
                          navigate(`/company/applicants`);
                        } else {
                          alert("No applicants found");
                        }
                      }}
                    />
                  ))}
                </>
              </>
            ))}

          {selectedButton === "Mcq" &&
            (RecuiterStore.loader ? (
              <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Loop to loaded Invitations */}
                {RecuiterStore.LoadedInvitations?.map((invitation) => (
                  <HistoryJobpostCard
                    verifiedStatus={null}
                    onClick={async (action) => {
                      console.log(action, "action");
                      // alert("Commig soon...");
                      await RecuiterStore.fetchRemainderMails(
                        invitation._id,
                        "mockTest"
                      );
                      RecuiterStore.setMailType("");
                      RecuiterStore.setMailTemplate("");
                      setData(invitation);
                      PopupStore.setMailTypePopup(true);
                    }}
                    job={invitation}
                    label={
                      invitation.mockTestName !== ""
                        ? invitation.mockTestName
                        : ""
                    }
                    cardType={"mcqCard"}
                    buttonLabels={[
                      `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                      `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                      `Technical: ${invitation?.noOfTechnicalQuestions}`,
                      `verbal: ${invitation?.noOfVerbalQuestions}`,
                    ]}
                    id={invitation?._id}
                    postedOn={formatDate(invitation.createdAt)}
                    cutOff={invitation.cutOff}
                    questions={invitation.noOfQuestions}
                    totalApplicants={invitation?.mockTestInvites.length}
                    rejected={invitation?.rejected?.length ?? "-"}
                    shortlisted={invitation?.shortListed?.length ?? "-"}
                    hired={invitation?.hired?.length ?? "-"}
                    hold={
                      invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length ?? "-"
                    }
                    status={invitation?.isOpen}
                    handleNavigation={() => {
                      if (invitation?.mockTestInvites.length > 0) {
                        localStorage.setItem("interviewId", invitation?._id);
                        RecuiterStore.setApplicantSkip(0);
                        navigate(
                          `/company/mocktest-applicants?mocktestId=${invitation._id}`
                        );
                      } else {
                        alert("No applicants found");
                      }
                    }}
                  />
                ))}
                {/* Loop to create 5 divs */}
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl shadow-lg shadow-gray-300 animate-pulse bg-gray-100 mt-[1rem]"
                  >
                    <div className="history-page flex items-center w-full p-2">
                      <div className="flex  gap-x-4">
                        {/* Logo */}
                        <div className="w-32 ml-2 h-32 bg-gray-200 rounded-full"></div>

                        {/* Job Info */}
                        <div className="flex-1 space-y-2 mt-4">
                          <div className="w-52 h-6 bg-gray-200 rounded"></div>
                          <div className="w-48 h-3 bg-gray-200 rounded"></div>
                          <div className="w-44 h-3 bg-gray-200 rounded"></div>
                          <div className="w-40 h-3 bg-gray-200 rounded"></div>
                        </div>

                        {/* Buttons */}
                        <div className="  flex ml-32  gap-2 ">
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                        </div>
                      </div>

                      {/* Job Details Section */}
                      <div className="mt-32 flex gap-2 -ml-[41rem]">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                      </div>

                      {/* Application Stats */}
                      <div className=" flex  gap-2 ml-[45rem] mb-20">
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                      </div>
                      <div className="w-32 h-6 mt-24 -ml-28 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {RecuiterStore.mockTest?.length === 0 && (
                  <div className="flex items-center justify-center text-xl text-primary font-bold h-[50vh]">
                    {" "}
                    Create an mcq to view
                  </div>
                )}
                {RecuiterStore.mockTest?.map((invitation) => (
                  <HistoryJobpostCard
                    verifiedStatus={null}
                    onClick={async (action) => {
                      console.log(action, "action");
                      // alert("Commig soon...");
                      await RecuiterStore.fetchRemainderMails(
                        invitation._id,
                        "mockTest"
                      );
                      RecuiterStore.setMailType("");
                      RecuiterStore.setMailTemplate("");
                      setData(invitation);
                      PopupStore.setMailTypePopup(true);
                    }}
                    job={invitation}
                    label={
                      invitation.mockTestName !== ""
                        ? invitation.mockTestName
                        : ""
                    }
                    cardType={"mcqCard"}
                    buttonLabels={[
                      `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                      `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                      `Technical: ${invitation?.noOfTechnicalQuestions}`,
                      `verbal: ${invitation?.noOfVerbalQuestions}`,
                    ]}
                    id={invitation?._id}
                    postedOn={formatDate(invitation.createdAt)}
                    cutOff={invitation.cutOff}
                    questions={invitation.noOfQuestions}
                    totalApplicants={invitation?.mockTestInvites.length}
                    rejected={invitation?.rejected?.length ?? "-"}
                    shortlisted={invitation?.shortListed?.length ?? "-"}
                    hired={invitation?.hired?.length ?? "-"}
                    hold={
                      invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length ?? "-"
                    }
                    status={invitation?.isOpen}
                    handleNavigation={() => {
                      if (invitation?.mockTestInvites.length > 0) {
                        localStorage.setItem("interviewId", invitation?._id);
                        RecuiterStore.setApplicantSkip(0);
                        navigate(
                          `/company/mocktest-applicants?mocktestId=${invitation._id}`
                        );
                      } else {
                        alert("No applicants found");
                      }
                    }}
                  />
                ))}
              </>
            ))}
          {selectedButton === "Resume Analyzer" &&
            (RecuiterStore.loader ? (
              <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">
                {/* Loop to loaded Invitations */}
                {RecuiterStore.LoadedInvitations?.map((invitation) => (
                  <HistoryJobpostCard
                    verifiedStatus={null}
                    onClick={async (action) => {
                      console.log(action, "action");
                      setRemainderLoader(true);
                      await RecuiterStore.fetchRemainderMails(
                        invitation._id,
                        "resumeSorting"
                      );
                      setRemainderLoader(false);
                      await getmails("resume");
                      RecuiterStore.setRemainderMailType("resume");
                      RecuiterStore.setMailType("");
                      RecuiterStore.setMailTemplate("");
                      setData(invitation);
                      PopupStore.setMailTypePopup(true);
                    }}
                    job={invitation}
                    label={
                      invitation.mockTestName !== ""
                        ? invitation.mockTestName
                        : ""
                    }
                    cardType={"resumeCard"}
                    buttonLabels={[
                      `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                      `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                      `Technical: ${invitation?.noOfTechnicalQuestions}`,
                      `verbal: ${invitation?.noOfVerbalQuestions}`,
                    ]}
                    id={invitation?._id}
                    postedOn={formatDate(invitation.createdAt)}
                    cutOff={invitation.cutOff}
                    questions={invitation.noOfQuestions}
                    totalApplicants={invitation?.applicantsCount}
                    rejected={invitation?.rejected?.length ?? "-"}
                    shortlisted={invitation?.shortListed?.length ?? "-"}
                    hired={invitation?.hired?.length ?? "-"}
                    hold={
                      invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length ?? "-"
                    }
                    status={invitation?.isOpen}
                    handleNavigation={() => {
                      if (invitation?.resumes?.length > 0) {
                        navigate(
                          `/company/resumescore/${invitation._id}${
                            invitation?.isSortingCompleted ? "" : "?save=true"
                          }`
                        );
                      } else {
                        alert("No Resumes found");
                      }
                    }}
                  />
                ))}
                {/* Loop to create 5 divs */}
                {Array.from({ length: 5 }).map((_, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl shadow-lg shadow-gray-300 animate-pulse bg-gray-100 mt-[1rem]"
                  >
                    <div className="history-page flex items-center w-full p-2">
                      <div className="flex  gap-x-4">
                        {/* Logo */}
                        <div className="w-32 ml-2 h-32 bg-gray-200 rounded-full"></div>

                        {/* Job Info */}
                        <div className="flex-1 space-y-2 mt-4">
                          <div className="w-52 h-6 bg-gray-200 rounded"></div>
                          <div className="w-48 h-3 bg-gray-200 rounded"></div>
                          <div className="w-44 h-3 bg-gray-200 rounded"></div>
                          <div className="w-40 h-3 bg-gray-200 rounded"></div>
                        </div>

                        {/* Buttons */}
                        {/* <div className="  flex ml-32  gap-2 "> 
                           <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                          <div className="w-24 h-6 bg-gray-200 rounded"></div>
                        </div> */}
                      </div>

                      {/* Job Details Section */}
                      <div className="mt-32 flex gap-2 -ml-[41rem]">
                        <div className="w-24 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                        <div className="w-10 h-4 bg-gray-200 rounded"></div>
                      </div>

                      {/* Application Stats */}
                      <div className=" flex  gap-2 ml-auto mb-20">
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                        <div className="w-8 h-8 bg-gray-200 rounded"></div>
                      </div>
                      <div className="w-32 h-6 mt-24 -ml-28 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {RecuiterStore.jd?.length === 0 && (
                  <div className="flex items-center justify-center text-xl text-primary font-bold h-[50vh]">
                    {" "}
                    create a resume analyzer to view
                  </div>
                )}
                {RecuiterStore.jd?.map((invitation) => (
                  <HistoryJobpostCard
                    verifiedStatus={null}
                    onClick={async (action) => {
                      console.log(action, "action");
                      setRemainderLoader(true);
                      await RecuiterStore.fetchRemainderMails(
                        invitation._id,
                        "resumeSorting"
                      );
                      setRemainderLoader(false);
                      await getmails("resume");
                      RecuiterStore.setRemainderMailType("resume");
                      RecuiterStore.setMailType("");
                      RecuiterStore.setMailTemplate("");
                      setData(invitation);
                      PopupStore.setMailTypePopup(true);
                    }}
                    job={invitation}
                    label={
                      invitation.mockTestName !== ""
                        ? invitation.mockTestName
                        : ""
                    }
                    cardType={"resumeCard"}
                    buttonLabels={[
                      `Aptitude: ${invitation?.noOfAptitudeQuestions}`,
                      `Reasoning: ${invitation?.noOfReasoningQuestions}`,
                      `Technical: ${invitation?.noOfTechnicalQuestions}`,
                      `verbal: ${invitation?.noOfVerbalQuestions}`,
                    ]}
                    id={invitation?._id}
                    postedOn={formatDate(invitation.createdAt)}
                    cutOff={invitation.cutOff}
                    questions={invitation.noOfQuestions}
                    totalApplicants={invitation?.applicantsCount}
                    rejected={invitation?.rejected?.length ?? "-"}
                    shortlisted={invitation?.shortListed?.length ?? "-"}
                    hired={invitation?.hired?.length ?? "-"}
                    hold={
                      invitation?.applicantsCount -
                        invitation?.rejected?.length -
                        invitation?.shortListed?.length ?? "-"
                    }
                    status={invitation?.isOpen}
                    handleNavigation={() => {
                      if (invitation?.resumes?.length > 0) {
                        navigate(
                          `/company/resumescore/${invitation._id}${
                            invitation?.isSortingCompleted ? "" : "?save=true"
                          }`
                        );
                      } else {
                        alert("No Resumes found");
                      }
                    }}
                  />
                ))}
              </>
            ))}
        </div>

        <div className="">
          {page > 1 ? (
            <ReactPaginate
              nextLabel={pag == page.toFixed(0) - 1 ? "" : ">"}
              className="flex justify-center items-center gap-5 pb-20 "
              onPageChange={handlePageClick}
              forcePage={pag}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={page}
              previousLabel={pag < 1 ? " " : "<"}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active-page-item"
              activeLinkClassName="active-page-link"
            />
          ) : (
            <div className="  pb-10 "></div>
          )}
        </div>
      </div>
    </>
  ));
}

export function Header({ title }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userDetail = JSON.parse(localStorage.getItem("user"));
    setUser(userDetail);
  }, []);

  return useObserver(() => (
    <div className="flex flex-row w-full items-center justify-between gap-2 mt-10">
      <div className="text-lg font-semibold md:w-[40%] lg:w-[40%] w-[90%] md:mx-0 lg:mx-0 mx-auto">
        <h1 className="text-4xl font-bold text-primary">{title}</h1>
      </div>
      <div className="bg-white relative md:w-[65%] lg:w-[65%] w-[85%] h-16 flex justify-between px-7 items-center rounded-full">
        <form className="flex w-full">
          <div className="flex justify-start items-center w-full ">
            <input
              type="text"
              placeholder="Search by Name, Role or Technology"
              // ref={searchValue}

              className=" placeholder-primary truncate text-lg outline-none h-10 w-[88%] md:w-[95%]"
            />
            <CiSearch className="text-4xl text-primary absolute right-4 md:right-8" />
          </div>
        </form>
      </div>
    </div>
  ));
}

export function Buttons({ Button, handleSelectedButton, pag }) {
  const [selectedButton, setSelectedButton] = useState(Button);
  const { RecuiterStore, PopupStore } = useStores();

  useEffect(() => {
    setSelectedButton(Button);
  }, [Button]);

  function getSub(template, variables) {
    // Replace placeholders in subject and body with variable values
    const filledSubject = template.replace(
      /\[([^\]]+)\]/g,
      (_, key) => variables[key] || `[${key}]`
    );

    return filledSubject;
  }

  function getBody(template, variables) {
    const filledBody = template.replace(
      /\[([^\]]+)\]/g,
      (_, key) => variables[key] || `[${key}]`
    );

    return filledBody;
  }

  const emails = [
    "example1@example.com",
    "example2@example.com",
    "example3@example.com",
    "example4@example.com",
    "example5@example.com",
    "example6@example.com",
  ];
  const subject =
    "Congratulations! You've Been Shortlisted for [Role Name] at [Company Name]!";
  const body = `
Dear [Candidate Name],

I hope this message finds you well.

We are pleased to inform you that your application for the [Role Name] position at [Company Name] has been shortlisted.
Your experience and qualifications caught our attention, and we are excited to learn more about you.
...
`;
  const handleSendMail = () => {
    alert("Mail sent!");
  };
  return useObserver(() => (
    <div className="flex md:overflow-x-visible lg:overflow-x-visible overflow-x-scroll  w-full gap-y-4 mt-3 no-scrollbar relative">
      <div className="hidden md:flex w-full gap-4 md-7">
        <button
          className={` w-fit px-5 md:text-base lg:text-base text-sm  rounded-lg  ${
            selectedButton === "All"
              ? "bg-primary text-white"
              : "text-[#747474] border border-primary"
          }`}
          onClick={() => {
            setSelectedButton("All");
            RecuiterStore.resetskip();
            handleSelectedButton("All");
          }}
        >
          All
        </button>
        <button
          className={` w-fit px-5 text-sm  rounded-lg  ${
            selectedButton === "job posts"
              ? "bg-primary text-white"
              : "text-[#747474] border border-primary"
          }`}
          onClick={() => {
            setSelectedButton("job posts");
            RecuiterStore.resetskip();
            handleSelectedButton("job posts");
          }}
        >
          Job Posts
        </button>
        <button
          className={`md:w-[9%] lg:w-[9%] min-w-fit  w-[26%] text-sm md:py-2 lg:py-2 px-5 rounded-lg  ${
            selectedButton === "Interviews"
              ? "bg-primary text-white"
              : "text-[#747474] border border-primary"
          }`}
          onClick={() => {
            setSelectedButton("Interviews");
            RecuiterStore.resetskip();
            handleSelectedButton("Interviews");
          }}
        >
          Interviews
        </button>
        <button
          className={` w-fit px-5 text-sm  rounded-lg  ${
            selectedButton === "Mcq"
              ? "bg-primary text-white"
              : "text-[#747474] border border-primary"
          }`}
          onClick={() => {
            setSelectedButton("Mcq");
            RecuiterStore.resetskip();
            handleSelectedButton("Mcq");
          }}
        >
          MCQ's
        </button>
        <button
          className={` w-fit px-5 text-sm  rounded-lg whitespace-nowrap  ${
            selectedButton === "Resume Analyzer"
              ? "bg-primary text-white"
              : "text-[#747474] border border-primary"
          }`}
          onClick={() => {
            setSelectedButton("Resume Analyzer");
            RecuiterStore.resetskip();
            handleSelectedButton("Resume Analyzer");
          }}
        >
          Resumes Analyzer
        </button>
      </div>
      <div className="h-full hidden md:flex absolute   right-1 items-center gap-4">
        <CustomButton
          text="Refresh"
          onClick={() => {
            if (Button === "All") {
              setSelectedButton("All");
              RecuiterStore.fetchAllInvitations(pag * 10);
              RecuiterStore.refreshObject.history = 1;
            }
            if (Button === "job posts") {
              // alert("hello");
              setSelectedButton("job posts");
              RecuiterStore.setRecuirterJobPostSkip(pag * 10);
              RecuiterStore.fetchJobPostsForHistory(true);
            }
            if (Button === "Interviews") {
              setSelectedButton("Interviews");
              RecuiterStore.setRecuirterInterviewSkip(pag * 10);
              RecuiterStore.fetchCompanyInvitations(true);
            }

            if (Button === "Mcq") {
              // alert("hell");
              setSelectedButton("Mcq");
              RecuiterStore.fetchmcqinvitation(pag * 10);
            }
            if (Button === "Resume Analyzer") {
              setSelectedButton("Resume Analyzer");
              RecuiterStore.fetchjd(pag * 10);
            }
          }}
          icon={IoMdRefresh}
        />
      </div>
      <div className=" w-full">
        <select
          className=" w-full md:hidden bg-[#EFEFEF] focus:outline-none border rounded-lg px-4 h-11 form-select appearance-none pr-8  bg-no-repeat"
          value={selectedButton}
          onChange={(e) => {
            setSelectedButton(e.target.value);
            RecuiterStore.resetskip();
            handleSelectedButton(e.target.value);
          }}
        >
          <option value={"All"}>All</option>
          <option value={"job posts"}>Job Posts</option>
          <option value={"Interviews"}>Interviews</option>
          <option value={"Mcq"}>Mcq's</option>
          <option value={"Resume Analyzer"}>Resume Analyzer</option>
        </select>
      </div>
      <div className=" gap-4 hidden">
        <ClientPopup />
        {/* <button
          className="flex border  px-4 rounded-lg text-[#747474] border-primary items-center gap-2 hover:bg-primary hover:text-white "
          onClick={() => {
            RecuiterStore.refreshData();
          }}
        >
          <IoMdRefresh /> Refresh
        </button> */}
        {!RecuiterStore.clients?.data ||
        RecuiterStore.clients.data.length < 1 ? null : (
          <select
            value={RecuiterStore.clientId}
            className={
              !RecuiterStore.clients?.data ||
              RecuiterStore.clients.data.length < 1
                ? "appearance-none w-24 focus:outline-none border border-primary  px-2 rounded-lg"
                : "w-24 focus:outline-none border border-primary  px-2 rounded-lg"
            }
            onChange={(e) => {
              RecuiterStore.setClientId(e.target.value);
              RecuiterStore.refreshData();
            }}
          >
            <option value="">All</option>
            {RecuiterStore.clients?.data?.map((data) => {
              return <option value={data._id}>{data.name}</option>;
            })}
          </select>
        )}
      </div>
    </div>
  ));
}

export function JobCard({
  client,
  type,
  title,
  currency,
  rate,
  handleClick,
  id,
  date,
  postedOn,
  salary,
  experience,
  location,
  details,
  workMode,
  openings,
  status,
  applied,
  attempted,
  shortlisted,
  hired,
  qualified,
  reasoning,
  verbal,
  technical,
  interviewType,
  interviewLevel,
  assessmentName,
  questions,
  cutOff,
  aptitude,
  buttonName,
  labels,
  createdAt,
  job,
}) {
  const [typeOfCard, setTypeOfCard] = useState(type);
  const { RecuiterStore, CommonStore, PopupStore } = useStores();
  const recuiterId = JSON.parse(localStorage.getItem("user"))._id;
  const jobPostLink =
    getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://reaidy.io/job/${id}`
      : `https://${getDomainForWhiteLabeling()}/jobpost/${id}`;
  const interviewLink = `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${id}`;
  const mcqLink =
    getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://user.reaidy.io/mcq-test/${id}`
      : `https://${getDomainForWhiteLabeling()}/dashboard/mocktest?mocktestId=${id}&recruiterId=${recuiterId}`;
  const clientmcqLink = `https://${getDomainForWhiteLabeling()}/share/mcq-applicants?mocktestId=${id}`;

  const clientLink = `https://${getDomainForWhiteLabeling()}/share/job-applicants/${id}`;
  const clientInterviewLink = `https://${getDomainForWhiteLabeling()}/share/applicants?id=${id}&clientId=${
    RecuiterStore.clientId
  }`;

  const { LabelStore } = useStores();

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLink = () => {
    if (typeOfCard === "JobPost") {
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
    if (typeOfCard === "interview") {
      let jobPostLink = interviewLink;
      let clientLink = clientInterviewLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
      // return {jobPostLink, clientLink};
    }
    if (typeOfCard === "MCQ") {
      // return mcqLink;
      let jobPostLink = mcqLink;
      let clientLink = clientmcqLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
    if (typeOfCard === "mockTest") {
      let jobPostLink = mcqLink;
      let clientLink = clientmcqLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
  };

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = handleLink();

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert(" link copied successfully");
  };

  const [isPopupVisible, setIsPopUpVisible] = useState(false);

  const onShareClick = () => {
    setIsPopUpVisible(true);
  };

  const handlePopUpVisible = (value) => {
    setIsPopUpVisible(value);
  };

  const handleDelete = () => {
    if (typeOfCard === "interview") {
      if (window.confirm("Are you sure you want to delete this interview?")) {
        RecuiterStore.deleteInterview(id);
        return handleMenuClose();
      }
    }
    if (typeOfCard === "mockTest") {
      if (window.confirm("Are you sure you want to delete this MCQ test?")) {
        RecuiterStore.deleteMockTest(id);
        return handleMenuClose();
      }
    } else {
      if (
        window.confirm(
          "All the applicants of this job post will be deleted. Are you sure you want to delete ?"
        )
      ) {
        RecuiterStore.deleteJobPost(id);
        return handleMenuClose();
      }
    }
  };

  const handleApplicantNavigation = () => {
    if (typeOfCard === "jobPost") {
      if (attempted === 0) {
        alert("You have zero applicants");
        return handleMenuClose();
      }
      localStorage.setItem("jobId", id);
      return navigate(`/company/job-applicants/${id}`);
    }
    if (typeOfCard === "interview") {
      if (attempted === 0) {
        alert("You have zero applicants");
        return handleMenuClose();
      }
      localStorage.setItem("interviewId", id);
      RecuiterStore.setApplicantSkip(0);

      return navigate(`/company/applicants/`);
    }
  };

  const handleDetailsNavigation = () => {
    if (typeOfCard === "jobPost") {
      return navigate(`/company/jobpost/${id}`);
    }
  };

  const handleStatus = () => {
    if (typeOfCard === "jobPost") {
      if (window.confirm("Do you want to change the status?")) {
        RecuiterStore.updateJobPost(!status, id);
        return handleMenuClose();
      }
    }
    if (typeOfCard === "interview") {
      if (window.confirm("Do you want to change the status?")) {
        RecuiterStore.updateCompanyInvitation(!status, id);
        return handleMenuClose();
      }
    }
  };

  const editJobPost = () => {
    CommonStore.setProgress(0);
    navigate(`/company/job-post?id=${id}&isEdit=true`);
  };

  return useObserver(() => (
    <>
      {title ? (
        <>
          <div className="p-6 mt-5 w-full bg-white shadow-2xl shadow-slate-200 rounded-lg flex flex-wrap justify-between items-start relative">
            <div
              className="absolute top-4 right-4"
              onClick={() => console.log(typeOfCard, " is the type of card")}
            >
              {/* <IconButton onClick={handleMenuClick}>
                <HiDotsVertical className="text-xl" />
              </IconButton> */}
              <div className="absolute right-6 top-6">
                {/* <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>

                  {typeOfCard === "JobPost" && (
                    <MenuItem onClick={editJobPost}>edit job post</MenuItem>
                  )}
                  
                  <MenuItem onClick={handleStatus}>
                    {status ? "close" : "open"}{" "}
                    {typeOfCard === "jobPost" ? "job post" : "interview"}
                  </MenuItem>
                  <MenuItem onClick={handleDelete}>
                    delete {typeOfCard === "jobPost" ? "job post" : "interview"}
                  </MenuItem>
                </Menu> */}
              </div>
            </div>
            <JobShare
              isPopupVisible={isPopupVisible}
              handlePopUpVisible={handlePopUpVisible}
              link={handleLink()}
              typeOfCard={typeOfCard}
            />
            <div className="md:w-[50%] lg:w-[50%] w-[90%] md:border-r-2 lg:border-r-2 border-r-none md:border-[#D1D8DF] lg:border-[#D1D8DF]">
              <div className="flex justify-between items-center w-[95%]">
                <div className="flex">
                  <h2 className="text-xl font-bold">{title}</h2>
                  <button className="px-4 py-1 text-primary font-medium ">
                    <p>[{type.charAt(0).toUpperCase() + type.slice(1)}]</p>
                  </button>
                </div>
                <h2 className="text-xl ">{client}</h2>
              </div>
              {date ? (
                <p className="text-gray-500 text-sm">
                  by company · Posted on {postedOn}
                </p>
              ) : (
                <p className="text-gray-500">
                  by company · Posted {postedOn} ago
                </p>
              )}
              <div className="mt-4 flex md:w-[90%] lg:w-[90%] w-full justify-between ">
                <div>
                  {salary && (
                    <div className="flex gap-2 px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      {/* {currency?.split("")[0] ?? "₹"} */}
                      <span>{salary}</span>
                      {rate && <span>{rate}</span>}
                    </div>
                  )}
                  {experience && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <AiOutlineClockCircle className="mr-2" />
                      <span className="whitespace-nowrap">
                        {experience} years of experience
                      </span>
                    </div>
                  )}
                  {location && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <MdOutlineLocationOn className="mr-2" />
                      <span>{location}</span>
                    </div>
                  )}
                  {interviewType && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Type of interview: {interviewType}</span>
                    </div>
                  )}
                  {interviewLevel && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Level of interview: {interviewLevel}</span>
                    </div>
                  )}
                  {assessmentName && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Assessment Name: {assessmentName}</span>
                    </div>
                  )}
                  {questions ? (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Number of questions: {questions}</span>
                    </div>
                  ) : null}
                  {cutOff && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>cut-off: {cutOff}%</span>
                    </div>
                  )}
                  {aptitude && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Aptitude: {aptitude}</span>
                    </div>
                  )}
                </div>
                <div>
                  {details && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Employment Type: {details}</span>
                    </div>
                  )}
                  {workMode && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span className="whitespace-nowrap">
                        Mode of work: {workMode}
                      </span>
                    </div>
                  )}
                  {openings && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474]">
                      <span>Openings: {openings}</span>
                    </div>
                  )}
                  {reasoning && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Reasoning: {reasoning}</span>
                    </div>
                  )}
                  {verbal && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Verbal: {verbal}</span>
                    </div>
                  )}
                  {technical && (
                    <div className="flex px-2 border-l-2 border-primary items-center text-[#747474] mb-2">
                      <span>Technical: {technical}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="hidden md:flex items-center justify-between w-[95%]">
                <div className="flex items-center gap-3">
                  <button
                    className={`${
                      type === "mockTest" ? "hidden" : ""
                    } mt-4 px-4 py-2 border border-gray-800 text-gray-800 rounded-lg `}
                    onClick={() => {
                      if (type === "JobPost") {
                        navigate(`/company/jobpost/${id}`);
                      }
                      if (type === "interview") {
                        console.log(job);
                        RecuiterStore.setJob(job);
                        PopupStore.setInterview(true);
                      }
                    }}
                  >
                    View {buttonName} details
                  </button>
                </div>
                <div className="flex items-center justify-center cursor-pointer gap-6">
                  {type == "JobPost" && (
                    <>
                      {labels ? (
                        <div>
                          {labels[0] ? (
                            <MdBookmark
                              className="mt-3 cursor-pointer text-primary text-2xl"
                              onClick={() => {
                                console.log(typeOfCard, "is the type of card");
                                console.log(toJS(labels));
                                LabelStore.setsection(
                                  typeOfCard === "JobPost"
                                    ? "jobPost"
                                    : "interview"
                                );
                                if (labels[0]._id) {
                                  const data = labels;
                                  const ids = data.map((item) => item._id);
                                  LabelStore.setApplicantLabelArray(ids);
                                } else {
                                  LabelStore.setApplicantLabelArray(labels);
                                }
                                LabelStore.setApplicantId(id);
                                LabelStore.setApplicants(true);
                              }}
                            />
                          ) : (
                            <MdBookmark
                              onClick={() => {
                                console.log("hello", toJS(labels));
                                LabelStore.setsection(
                                  typeOfCard === "JobPost"
                                    ? "jobPost"
                                    : "interview"
                                );
                                LabelStore.setApplicantLabelArray(labels);
                                LabelStore.setApplicantId(id);
                                LabelStore.setApplicants(true);
                              }}
                              className="mt-3 cursor-pointer text-gray-300 text-2xl"
                            />
                          )}
                        </div>
                      ) : null}
                    </>
                  )}
                  <AiOutlineShareAlt
                    className="text-xl cursor-pointer mt-3 hover:text-primary "
                    onClick={onShareClick}
                  />

                  <AiOutlineDelete
                    className="cursor-pointer mt-3 text-xl text-[#2b2b2c] hover:text-red-500"
                    onClick={handleDelete}
                  />
                </div>
              </div>
            </div>
            {LabelStore.Applicants && <ApplicantLabelPopup />}
            <div className="md:w-[40%] lg:w-[40%] w-[90%] md:mx-auto lg:mx-auto mx-0 md:mt-0 lg:mt-0 mt-2">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="text-lg font-semibold">Applications</h3>
                  <p className="text-sm">
                    Status:{" "}
                    <span className={`text-${status ? "green" : "red"}-500`}>
                      {status ? "Active" : "Closed"}
                    </span>
                  </p>
                </div>
                <button
                  className="text-primary underline"
                  onClick={() => {
                    if (attempted === 0) {
                      alert("You have zero applicants");
                      return;
                    }
                    RecuiterStore.setTech(title);
                    RecuiterStore.filterApplicantsByInvitationId(id);
                    if (handleClick != null) handleClick();
                  }}
                >
                  View Applicants
                </button>
              </div>

              <div className="mt-4 flex w-full justify-between items-center">
                <div className="w-[45%] mr-auto flex flex-col items-start">
                  <div className="text-primary text-3xl font-bold w-full h-[90px] rounded-lg flex justify-center items-center bg-[#f8e3d4]">
                    {applied && (
                      <p className="text-3xl font-bold text-primary">
                        {applied}
                      </p>
                    )}
                    {attempted && (
                      <p className="text-3xl font-bold text-primary">
                        {attempted}
                      </p>
                    )}
                  </div>
                  {applied && (
                    <div className="ml-2">
                      {/* <p className="font-semibold">{applied}</p> */}
                      <p className="text-[#747474]">Applied</p>
                    </div>
                  )}
                  {attempted !== null && (
                    <div className="ml-2">
                      {/* <p className="font-semibold">{attempted}</p> */}
                      <p className="text-[#747474]">Attempted</p>
                    </div>
                  )}
                </div>

                <div className="w-[45%] ml-auto flex flex-col items-start">
                  <div className="bg-[#acee8e] w-full text-green-800 text-3xl font-bold h-[90px]  rounded-lg flex justify-center items-center">
                    {shortlisted && (
                      <p className="text-3xl font-bold text-green-800">
                        {shortlisted}
                      </p>
                    )}
                    {qualified && (
                      <p className="text-3xl font-bold text-green-800">
                        {qualified}
                      </p>
                    )}
                  </div>
                  {/* {shortlisted && (
              <div className="ml-2"> */}
                  {/* <p className="font-semibold">{shortlisted}</p> */}
                  {/* <p className="text-[#747474]">Shortlisted</p>
              </div>
            )} */}
                  {shortlisted !== null && (
                    <div className="ml-2">
                      {/* Render different text based on typeofCard */}
                      <p className="text-[#747474]">
                        {typeOfCard === "interview"
                          ? "Completed"
                          : "Shortlisted"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="hidden">
                <p className="text-[#747474] opacity-50 text-sm font-medium flex justify-end mt-5">
                  Id: {id}
                </p>
              </div>
            </div>

            {/* Buttons for mobile */}
            <div className="flex justify-between md:hidden w-[95%] mt-4 space-y-2">
              <div>
                <button
                  className="px-4 py-2 border border-gray-800 text-gray-800 rounded-lg"
                  onClick={() => {
                    if (type === "JobPost") {
                      navigate(`/company/jobpost/${id}`);
                    }
                  }}
                >
                  View {buttonName} details
                </button>
              </div>
              <div className="flex gap-6 justify-between">
                {/* <IoBookmarkOutline className="text-2xl" /> */}
                <AiOutlineShareAlt
                  className="text-xl cursor-pointer"
                  onClick={onShareClick}
                />
                <AiOutlineDelete
                  className="cursor-pointer text-xl text-[#2b2b2c] hover:text-red-500"
                  onClick={handleDelete}
                />
              </div>
            </div>
            <div className="flex flex-row-reverse w-full">
              <div className="w-full md:w-[45%] lg:w-[45%] flex  justify-between">
                <p className="text-[#747474] opacity-50 text-sm font-medium flex justify-end mt-2">
                  ID: {id}
                </p>
                <p className="text-[#747474] opacity-50 text-sm font-medium flex justify-end mt-2">
                  {createdAt}
                </p>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  ));
}
